module.exports = __webpack_public_path__ + "img/dashboard-tag-line.329b9334.svg";